import { createRouter, createWebHistory } from 'vue-router'
import { useAuthStore } from '@/store/auth'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // { path: '/', redirect: '/login' },
    // {path:'/', component: () => import('@/views/TestPage.vue')},
    {path:'/',component:() => import('@/views/LoginPage.vue')},
    // {path:'/',component:() => import('@/views/HomePage.vue')},
    { path: '/login', component: () => import('@/views/LoginPage.vue') },
    {
      path:'/loginalarm',
      component:() => import('@/views/LoginAlarmPage.vue'),
    },
    {
      path:'/redirection',
      component:() => import('@/views/HomePage.vue'),
      meta:{requiresAuth:true}
    },
    {
      path:'/alarmgmt',
      component:() => import('@/views/AlarmMgmt.vue')
    }
  ]
})

router.beforeEach((to) => {
  const authStore = useAuthStore()
  if (to.meta.requiresAuth && !authStore.isAuthenticated) {
    return '/login'
  }
})

export default router
